import axios from "axios";

// Axios 요청 전에 실행될 인터셉터를 설정
axios.interceptors.request.use(
  (config) => {
    // 여기서 토큰 만료 및 유효성 검사를 수행
    if (tokenExpired()) {
      // 토큰이 만료된 경우, 로그아웃 또는 다른 처리 수행
      logoutOrPerformOtherAction();

      return Promise.reject(new Error("Token Expired"));
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 엑세스 토큰 JSON 형식으로 인코딩하는 함수
function decodeJwtPayload(jwt) {
  const base64UrlPayload = jwt.split(".")[1];
  const base64 = base64UrlPayload.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

// 토큰이 만료되었는지 확인
function tokenExpired() {
  // 토큰의 만료 날짜와 현재 날짜를 비교하여 유효성을 확인
  const token = sessionStorage.getItem("Token");
  if (token) {
    const tokenExpirationDate = decodeJwtPayload(
      JSON.stringify(token).replace("Bearer ", "")
    ).exp;

    const currentTime = Math.floor(Date.now() / 1000);

    // 현재 날짜와 토큰 만료 날짜를 비교
    if (currentTime >= tokenExpirationDate) {
      // 토큰이 만료된 경우
      return true;
    } else {
      // 토큰이 유효한 경우
      return false;
    }
  } else {
    return false;
  }
}

// 로그아웃 또는 다른 처리
function logoutOrPerformOtherAction() {
  // 여기에 로그아웃 또는 다른 원하는 처리를 구현
  // 예를 들어, 로그아웃을 수행하거나 다른 사용자 정의 로직 실행

  //sessionStorage 정보 삭제
  window.sessionStorage.removeItem("userInfo");
  window.sessionStorage.removeItem("Token");
  window.sessionStorage.removeItem("tokenLogin");

  // 로그인 페이지로 이동
  window.location.href = "/";
}

// post 방식
export const executeQuery = ({
  url,
  data,
  headers,
  success,
  error,
  fail,
  param,
}) => {
  // axios 관련
  axios.defaults.baseURL = window.location.protocol + "//localhost" + "/react";

  // const params = new ();

  // Object.keys(data).map((element) => {
  //   // .keys(): 주어진 data의 "id" , "password" 를 배열로 반환 ["id", "password"] // 반환된 배열을 호출한 결과로 모아 새로운 배열로 반환
  //   if (typeof data[element] == "object") {
  //     //주어진 data의 객체가 "object"타입이면
  //     console.log("data[element] length", data[element].length);
  //     console.log("data[element]", data[element]);
  //     if (data[element] !== null) {
  //       for (let i = 0; i < data[element].length; i++) {
  //         params.append(element + "[]", data[element][i]);
  //       }
  //     }
  //   } else {
  //     params.append(element, data[element]);
  //   }
  //   // console.log("jongchan.won", typeof data[element]);
  // });

  axios({
    method: "post", //post방식으로
    url,
    headers,
    data: data,
    params: param,
    // withCredentials: true,
  })
    .then((res) => {
      console.log("Res", res);

      if (res.status !== 200) {
        // 대답이 실패
        // alert("서버접속에 실패하였습니다. 관리자에게 문의해주시기 바랍니다.");
        console.log("fail1", res);
        console.log(res.data);
        fail(res.data);
      }
      if (res.status == 200) {
        console.log("success", res);
        success(res);
      }
    })
    .catch((err) => {
      if (fail) {
        console.log("fail3", err);
        fail(err);
      } else {
        console.log("fail2", err);
        alert("서버접속에 실패하였습니다. 관리자에게 문의해주시기 바랍니다.");
      }
    });
};

//get 방식
export const executeQueryGet = ({
  url,
  responseType,
  param,
  headers,
  success,
  error,
  fail,
}) => {
  // axios 관련
  axios.defaults.baseURL = window.location.protocol + "//localhost" + "/react";

  // const params = new FormData();

  // Object.keys(param).map((element) => {
  //   // .keys(): 주어진 data의 "id" , "password" 를 배열로 반환 ["id", "password"] // 반환된 배열을 호출한 결과로 모아 새로운 배열로 반환
  //   if (typeof param[element] == "object") {
  //     //주어진 data의 객체가 "object"타입이면
  //     console.log("data[element] length", param[element].length);
  //     console.log("data[element]", param[element]);
  //     if (param[element] !== null) {
  //       for (let i = 0; i < param[element].length; i++) {
  //         params.append(element + "[]", param[element][i]);
  //       }
  //     }
  //   } else {
  //     params.append(element, param[element]);
  //   }
  // });

  axios({
    method: "get", //get방식으로
    url,
    responseType,
    params: param,
    headers,
  })
    // axios
    //   .get(url, {
    //     params: param,
    //     headers,
    //   })
    .then((res) => {
      console.log("Res", res);

      if (res.status !== 200) {
        // 대답이 실패
        // alert("서버접속에 실패하였습니다. 관리자에게 문의해주시기 바랍니다.");
        console.log("fail1", res);
        console.log(res.data);
        fail(res.data);
      }
      if (res.status == 200) {
        //대답이 있다면
        //대답성공
        console.log("success", res);
        success(res);
      }
    })
    .catch((err) => {
      if (fail) {
        console.log("fail3", err);
        fail(err);
      } else {
        console.log("fail2", err);
        alert("서버접속에 실패하였습니다. 관리자에게 문의해주시기 바랍니다.");
      }
    });
};

// patch 방식
export const executeQueryPatch = ({
  url,
  data,
  headers,
  success,
  error,
  fail,
  param,
}) => {
  // axios 관련
  axios.defaults.baseURL = window.location.protocol + "//localhost" + "/react";

  // const params = new FormData();

  // Object.keys(param).map((element) => {
  //   // .keys(): 주어진 data의 "id" , "password" 를 배열로 반환 ["id", "password"] // 반환된 배열을 호출한 결과로 모아 새로운 배열로 반환
  //   if (typeof param[element] == "object") {
  //     //주어진 data의 객체가 "object"타입이면
  //     console.log("data[element] length", param[element].length);
  //     console.log("data[element]", param[element]);
  //     if (param[element] !== null) {
  //       for (let i = 0; i < param[element].length; i++) {
  //         params.append(element + "[]", param[element][i]);
  //       }
  //     }
  //   } else {
  //     params.append(element, param[element]);
  //   }
  // });

  axios({
    method: "patch", // PATCH 요청으로 설정
    url,
    data: data,
    params: param,
    headers,
  })
    .then((res) => {
      console.log("Res", res);

      if (res.status !== 200) {
        // 대답이 실패
        // alert("서버접속에 실패하였습니다. 관리자에게 문의해주시기 바랍니다.");
        console.log("fail1", res);
        console.log(res.data);
        fail(res.data);
      }
      if (res.status == 200) {
        //대답이 있다면
        //대답성공
        console.log("success", res);
        success(res);
      }
    })
    .catch((err) => {
      if (fail) {
        console.log("fail3", err);
        fail(err);
      } else {
        console.log("fail2", err);
        alert("서버접속에 실패하였습니다. 관리자에게 문의해주시기 바랍니다.");
      }
    });
};

// delete 방식
export const executeQueryDelete = ({
  url,
  data,
  param,
  headers,
  success,
  error,
  fail,
}) => {
  // axios 관련
  axios.defaults.baseURL = window.location.protocol + "//localhost" + "/react";

  // const params = new FormData();

  // Object.keys(param).map((element) => {
  //   // .keys(): 주어진 data의 "id" , "password" 를 배열로 반환 ["id", "password"] // 반환된 배열을 호출한 결과로 모아 새로운 배열로 반환
  //   if (typeof param[element] == "object") {
  //     //주어진 data의 객체가 "object"타입이면
  //     console.log("data[element] length", param[element].length);
  //     console.log("data[element]", param[element]);
  //     if (param[element] !== null) {
  //       for (let i = 0; i < param[element].length; i++) {
  //         params.append(element + "[]", param[element][i]);
  //       }
  //     }
  //   } else {
  //     params.append(element, param[element]);
  //   }
  // });

  axios({
    method: "delete", // Delete 요청으로 설정
    url,
    params: param,
    data: data,
    headers,
  })
    .then((res) => {
      console.log("Res", res);

      if (res.status !== 200) {
        console.log("fail1", res);
        console.log(res.data);
        fail(res.data);
      }
      if (res.status == 200) {
        console.log("success", res);
        success(res);
      }
    })
    .catch((err) => {
      if (fail) {
        console.log("fail3", err);
        fail(err);
      } else {
        console.log("fail2", err);
        alert("서버접속에 실패하였습니다. 관리자에게 문의해주시기 바랍니다.");
      }
    });
};

export const addCommas = (x) => {
  // 콤마 추가
  let parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const removeCommas = (num) => {
  // 콤마 제거
  let number = num.toString().replace(/,/g, "");
  return number;
};

export const leftpad = (val, resultLength = 2, leftpadChar = "0") => {
  return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
    String(val).length
  );
};

export const dateAsYYYYMMDD = (date) => {
  // date 형식 -> YYYYMMDD 형식으로 변환
  return (
    date.getFullYear() +
    "-" +
    leftpad(date.getMonth() + 1, 2) +
    "-" +
    leftpad(date.getDate(), 2)
  );
};

export const dateAsYYYYMMDDHHMM = (date, sec) => {
  // date 형식 -> YYYYMMDDHHMM 형식으로 변환
  return (
    date.getFullYear() +
    "-" +
    leftpad(date.getMonth() + 1, 2) +
    "-" +
    leftpad(date.getDate(), 2) +
    " " +
    leftpad(date.getHours(), 2) +
    ":" +
    leftpad(date.getMinutes(), 2) +
    ":" +
    leftpad(sec, 2)
  );
};

export const YYYYMMDDHHMMSSToDate = (date) => {
  // YYYYMMDDHHMMSS 형식 -> date형식으로 변환
  return new Date(
    date.replace(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/, "$1-$2-$3 $4:$5:$6")
  );
};

export const serverHost = () => {
  let serverHost = "";
  if (window.location.hostname == "localhost") {
    serverHost = window.location.protocol + "//" + window.location.hostname;
  } else if (window.location.hostname == "cms-dev.angkorchat.net") {
    serverHost = "http://cms-dev.angkorchat.net";
  } else {
    serverHost = "https://cms.angkorchats.com";
  }
  return serverHost;
};
